module.exports = __webpack_public_path__ + "static/media/Advice from a Caterpillar (Part 2).d061ef90.jpg";